/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetMeanValueForStressArea$Params {
  code: 'BASE' | 'DIST' | 'GRAVEL' | 'OTHER' | 'LEVEL' | 'COMPACT';
  stressAreaId: string;
}

export function getMeanValueForStressArea(http: HttpClient, rootUrl: string, params: GetMeanValueForStressArea$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
  const rb = new RequestBuilder(rootUrl, getMeanValueForStressArea.PATH, 'get');
  if (params) {
    rb.path('code', params.code, {});
    rb.path('stressAreaId', params.stressAreaId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
    })
  );
}

getMeanValueForStressArea.PATH = '/v1/raster/value/mean/{code}/{stressAreaId}';
